import { Switch } from "@mui/material";
import { useSynchronizedState } from "@solidwhite/multiuser";
import { useTranslation } from "react-i18next";

const CursorToggle = ({ ...props }) => {
  const [enableCursors, setEnableCursors] = useSynchronizedState("enable-cursors", true);

  const { t } = useTranslation();

  const handleChange = (e) => {
    // console.log(e.target.checked);
    setEnableCursors(e.target.checked);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        background: "black",
      }}
    >
      <div style={{ pointerEvents: "all" }}>
        <Switch checked={enableCursors} color="primary" onChange={handleChange} />
      </div>
      <div style={{ color: "white" }}>USER CURSORS</div>
    </div>
  );
};

export default CursorToggle;
